import Vue from 'vue';
import Router from 'vue-router';

import LogIn from '@/views/User/LogIn.vue';
import InitialScreen from '@/views/InitialScreen.vue';
import Dashboard from '@/views/Dashboard.vue';
import ResetPassword from '@/components/User/ResetPassword.vue';
import ResetPin from '@/components/User/ResetPin.vue';
import IdentitiesChoose from '@/views/Admin/IdentitiesChoose.vue';
import OrderInformation from '@/components/Finances/OrderInformation.vue';
import OrderDetails from '@/components/User/Wallet/OrderDetails.vue';
const Calendar = () => import('@/views/Calendar.vue');
const Messages = () => import('@/views/Messages.vue');
const Options = () => import('@/views/Options.vue');
const Documents = () => import('@/views/Documents.vue');
const UserCorporationLinks  = () => import('@/views/UserCorporationLinks.vue');
const UserTickets = () => import('@/views/UserTickets.vue');
const UserTicketsDetails = () => import('@/views/UserTicketsDetails.vue');
const UserTicketsChat = () => import('@/views/UserTicketsChat.vue');
const UserTicketsAssignment = () => import('@/views/UserTicketsAssignment.vue');
const UserSharedFacilities = () => import('@/views/UserSharedFacilities.vue');
const UserWallet = () => import('@/views/UserWallet.vue');
const UserSubscriptions = () => import('@/views/UserSubscriptions.vue');
const UserUnits = () => import('@/views/UserUnits.vue');
const UserUnitsDetails = () => import('@/views/UserUnitsDetails.vue');
const UserInbox = () => import('@/views/UserInbox.vue');
const UserConversationChat = () => import('@/views/UserConversationChat.vue');
const PublicProfile = () => import('@/views/User/PublicProfile.vue');
const Contacts = () => import('@/views/Contacts.vue');
const ImageCapture = () => import('@/components/Media/ImageCapture.vue');
const ImageCropper = () => import('@/components/Media/ImageCropper.vue');

const AllUsers = () => import('@/views/User/AllUsers.vue');
const OptionsImage = () => import('@/views/OptionsImage.vue');
const MobileConfirmationDialog = () => import('@/components/Dialogs/MobileConfirmationDialog.vue');
const MobileConfirmAreYouSure = () => import('@/components/Dialogs/MobileConfirmAreYouSure.vue');
const MobileThankYouDialog = () => import('@/components/Dialogs/MobileThankYouDialog.vue');
const PrivacyPolicyScreen = () => import('@/components/Dialogs/PrivacyPolicyScreen.vue');
const SignatureFrame = () => import('@/components/Documents/SignatureFrame.vue');
const DocumentSigned = () => import('@/components/Documents/DocumentSigned.vue');
const Document = () => import('@/components/Documents/Document.vue');
const EventFeedView = () => import('@/components/NewsFeed/EventFeedView.vue');
const Notification = () => import('@/components/NewsFeed/Notification.vue');
const ConvertTicket = () => import('@/views/ConvertTicket.vue');

// TODO: Remove afterwards
const Spinner = () => import('@/components/Media/Spinner.vue');

// Documents
const ReadDocument = () => import('@/components/Documents/MobileDocumentAttachment.vue');
const DocumentSign = () => import('@/components/Documents/DocumentSign.vue');

// Admin panel routes
const AdminProjects = () => import('@/views/Admin/Projects.vue');
const ProjectLanding = () => import('@/views/Admin/ProjectLanding.vue');
const AdminDocuments = () => import('@/views/Admin/Documents.vue');
const AdminBuildings = () => import('@/views/Admin/Buildings.vue');
const AdminUserManagement = () => import('@/views/Admin/UserManagement.vue');
const AdminNotifications = () => import('@/views/Admin/Notifications.vue');
const AdminEvents = () => import('@/views/Admin/Events.vue');
const AdminMessageSystem = () => import('@/views/Admin/MessageSystem.vue');
const AdminVariants = () => import('@/views/Admin/Variants.vue');
const AdminProperties = () => import('@/views/Admin/Properties.vue');
const AdminPropertiesLanding = () => import('@/views/Admin/PropertyLanding.vue');
const AdminTickets = () => import('@/views/Admin/Tickets.vue');
const AdminTicketAttributes = () => import('@/views/Admin/TicketAttributes.vue');
const AdminTicketDefects = () => import('@/views/Admin/AdminTicketDefects.vue');
const AdminWaitingLists = () => import('@/views/Admin/WaitingLists.vue');
const AdminWaitingListsEmbed = () => import('@/views/Admin/WaitingListsEmbed.vue');
const AdminPresentationFlows = () => import('@/views/Admin/PresentationFlows.vue');
const UnpaidPayments = () => import('@/views/Admin/UnpaidPayments.vue');
const CorpTransactions = () => import('@/views/Admin/CorpTransactions.vue');
const FinanceControl = () => import('@/views/Admin/FinanceControl.vue');
const AdminIntegrations = () => import('@/views/Admin/Integrations.vue');
const AdminLocalization = () => import('@/views/Admin/Localization.vue');
const AdminProfile = () => import('@/views/Admin/AdminProfile.vue');
const AdminEventLogs = () => import('@/views/Admin/EventLogs.vue');
const AdminCorporationConfigs = () => import('@/views/Admin/CorporationConfigs.vue');
const AdminSharedFacilities = () => import('@/views/Admin/SharedFacilities.vue');
const AddSharedFacility = () => import('@/views/Admin/AddSharedFacility.vue');
const EditSharedFacility = () => import('@/views/Admin/EditSharedFacility.vue');
const RolesAndPermissions = () => import('@/views/Admin/RolesAndPermissions.vue');
const AdminGroupings = () => import('@/views/Admin/Groupings.vue');
const AdminGrouping = () => import('@/views/Admin/Grouping.vue');
const AdminAddGrouping = () => import('@/views/Admin/AddGrouping.vue');
const AdminEditGrouping = () => import('@/views/Admin/EditGrouping.vue');
const AdminTenantProfile = () => import('@/views/Admin/TenantProfile.vue');
const AdminSystemTools = () => import('@/views/Admin/SystemTools.vue');
const ChannelList = () => import('@/views/Channels/ChannelList/ChannelList.vue');
const Channel = () => import('@/views/Channels/Channel/Channel.vue');

const ChartsDemo = () => import('@/views/ChartsDemo/ChartsDemo.vue');

const BookFacilityOverlay = () => import('@/components/User/SharedFacilities/BookFacilityOverlay.vue');

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'landing',
            component: InitialScreen,
        },
        {
            path: '/user/identities',
            name: 'identities-choose',
            component: IdentitiesChoose,
        },
        {
            path: '/user/dashboard',
            name: 'dashboard',
            component: Dashboard,
        },
        {
            path: '/notifications/:notificationId',
            name: 'notification',
            component: Notification,
        },
        {
            path: '/events/:eventId',
            name: 'event',
            component: EventFeedView,
        },
        {
            path: '/user/messages/:conversationId?/:messageId?',
            name: 'messages',
            component: Messages,
        },
        {
            path: '/user/calendar',
            name: 'calendar',
            component: Calendar,
        },
        {
            path: '/user/login',
            name: 'login',
            component: LogIn,
        },
        {
            path: '/user/profile',
            name: 'user-profile',
            component: PublicProfile,
        },
        {
            path: '/user/contacts',
            name: 'user-contacts',
            component: Contacts,
        },
        {
            path: '/user/all-users',
            name: 'all-users',
            component: AllUsers,
        },
        {
            path: '/user/reset-password',
            name: 'reset-password',
            component: ResetPassword,
        },
        {
            path: '/user/reset-pin-code',
            name: 'reset-pin-code',
            component: ResetPin,
        },
        {
            path: '/debug/media/image-capture',
            name: 'image-capture',
            component: ImageCapture,
        },
        {
            path: '/user/corporation-links',
            name: 'corporation-links',
            component: UserCorporationLinks,
        },
        {
            path: '/user/documents',
            name: 'documents',
            component: Documents,
        },
        {
            path: '/user/tickets',
            name: 'tickets',
            component: UserTickets,
        },
        {
            path: '/user/units',
            name: 'units',
            component: UserUnits,
        },
        {
            path: '/user/units/:unitId',
            name: 'units-details',
            component: UserUnitsDetails,
        },
        {
            path: '/user/inbox',
            name: 'inbox',
            component: UserInbox,
        },
        {
            path: '/user/inbox/:inboxId',
            name: 'inbox-chat',
            component: UserConversationChat,
        },
        {
            path: '/user/tickets/:ticketId',
            name: 'tickets-details',
            component: UserTicketsDetails,
        },
        {
            path: '/user/chat/tickets/:ticketId',
            name: 'tickets-chat',
            component: UserTicketsChat,
        },
        {
            path: '/user/re-assignment/tickets/:ticketId',
            name: 'tickets-reassignment',
            component: UserTicketsAssignment,
        },
        {
            path: '/user/shared-facilities',
            name: 'shared-facilities',
            component: UserSharedFacilities,
        },
        {
            path: '/user/book-facility',
            name: 'book-facility',
            component: BookFacilityOverlay,
        },
        {
            path: '/user/wallet',
            name: 'my-wallet',
            component: UserWallet,
        },
        {
            path: '/user/subscriptions',
            name: 'user-subscriptions',
            component: UserSubscriptions,
        },
        {
            path: '/user/wallet/:transactionId',
            name: 'transaction-details',
            component: OrderInformation,
        },
        {
            path: '/user/order/:orderId',
            name: 'order-details',
            component: OrderDetails,
        },
        {
            path: '/documents/:documentId',
            name: 'document',
            component: Document,
        },
        {
            path: '/document/:documentId/read',
            name: 'documentRead',
            component: ReadDocument,
        },
        {
            path: '/document/:documentId/sign',
            name: 'documentSign',
            component: DocumentSign,
        },
        {
            path: '/document/:documentId/signed',
            name: 'documentSigned',
            component: DocumentSigned,
        },
        {
            path: '/user/options',
            name: 'options',
            component: Options,
        },
        {
            path: '/dialog/confirmation',
            name: 'confirmation',
            component: MobileConfirmationDialog,
        },
        {
            path: '/dialog/confirmAreYouSure',
            name: 'confirmAreYouSure',
            component: MobileConfirmAreYouSure,
        },
        {
            path: '/dialog/thankYou',
            name: 'thankYouDialog',
            component: MobileThankYouDialog,
        },
        {
            path: '/dialog/privacyPolicyScreen',
            name: 'privacyPolicyScreen',
            component: PrivacyPolicyScreen,
        },
        {
            path: '/option/image',
            name: 'option-image',
            component: OptionsImage,
        },
        {
            path: '/signature',
            name: 'signature',
            component: SignatureFrame,
        },
        {
            path: '/image-cropper',
            name: 'imageCropper',
            component: ImageCropper,
        },
        {
            path: '/admin/corporation/configs',
            name: 'admin-corporation-configs',
            component: AdminCorporationConfigs,
        },
        {
            path: '/admin/projects',
            name: 'admin-projects',
            component: AdminProjects,
        },
        {
            path: '/admin/projects/:projectId',
            name: 'admin-project-details',
            component: ProjectLanding,
        },
        {
            path: '/admin/unit-groups',
            name: 'admin-unit-groups',
            component: AdminBuildings,
        },
        {
            path: '/admin/documents',
            name: 'admin-documents',
            component: AdminDocuments,
        },
        {
            path: '/admin/user-management/:type/:tenantId?',
            name: 'admin-user-management',
            component: AdminUserManagement,
        },
        {
            path: '/admin/broadcast',
            name: 'admin-notifications',
            component: AdminNotifications,
        },
        {
            path: '/admin/events',
            name: 'admin-events',
            component: AdminEvents,
        },
        {
            path: '/admin/messages/:conversationId?',
            name: 'admin-messages',
            component: AdminMessageSystem,
        },
        {
            path: '/admin/unit-types',
            name: 'admin-unit-types',
            component: AdminVariants,
        },
        {
            path: '/admin/units',
            name: 'admin-units',
            component: AdminProperties,
        },
        {
            path: '/admin/units/:unitId',
            name: 'admin-unit-details',
            component: AdminPropertiesLanding,
        },
        {
            path: '/admin/tickets/:ticketId?',
            name: 'admin-tickets',
            component: AdminTickets,
        },
        {
            path: '/admin/ticket/attributes',
            name: 'admin-ticket-attributes',
            component: AdminTicketAttributes,
        },
        {
            path: '/admin/ticket/defects',
            name: 'admin-ticket-defects',
            component: AdminTicketDefects,
        },
        {
            path: '/admin/waiting-lists',
            name: 'admin-waiting-lists',
            component: AdminWaitingLists,
        },
        {
            path: '/admin/waiting-lists-embed',
            name: 'admin-waiting-lists-embed',
            component: AdminWaitingListsEmbed,
        },
        {
            path: '/admin/finances/arrears',
            name: 'arrears',
            component: UnpaidPayments,
        },
        {
            path: '/admin/finances/transactions',
            name: 'transactions',
            component: CorpTransactions,
        },
        {
            path: '/admin/finances/control',
            name: 'finance-control',
            component: FinanceControl,
        },

        {
            path: '/admin/presentation-flow',
            name: 'admin-presentation-flow',
            component: AdminPresentationFlows,
        },
        {
            path: '/admin/integrations',
            name: 'admin-integrations',
            component: AdminIntegrations,
        },
        {
            path: '/admin/localization',
            name: 'admin-localization',
            component: AdminLocalization,
        },
        {
            path: '/admin/profile',
            name: 'admin-profile',
            component: AdminProfile,

        },
        {
            path: '/admin/notifications',
            name: 'admin-eventlogs',
            component: AdminEventLogs,

        },
        {
            path: '/admin/shared-facilities',
            name: 'admin-shared-facilities',
            component: AdminSharedFacilities,
        },
        {
            path: '/admin/shared-facilities/create',
            name: 'admin-shared-facilities-create',
            component: AddSharedFacility,
        },
        {
            path: '/admin/shared-facilities/update/:facilityId',
            name: 'admin-shared-facilities-update',
            component: EditSharedFacility,
        },
        {
            path: '/admin/permissions',
            name: 'admin-permissions',
            component: RolesAndPermissions,
        },
        {
            path: '/user/convert/:conversationId',
            name: 'convert-ticket-details',
            component: ConvertTicket,
        },
        {
            path: '/admin/groupings',
            name: 'admin-groupings',
            component: AdminGroupings,
        },
        {
            path: '/admin/grouping/:groupingId/preview',
            name: 'admin-grouping',
            component: AdminGrouping,
        },
        {
            path: '/admin/grouping/add',
            name: 'admin-grouping-add',
            component: AdminAddGrouping,
        },
        {
            path: '/admin/grouping/:groupingId/edit',
            name: 'admin-grouping-edit',
            component: AdminEditGrouping,
        },
        {
            path: '/admin/tenant/profile/:profileId',
            name: 'admin-tenant-profile',
            component: AdminTenantProfile,
        },
        // TODO: Remove afterwards
        {
            path: '/user/spinner',
            name: 'spinner',
            component: Spinner,
        },
        {
            path: '/demo/charts',
            name: 'charts-demo',
            component: ChartsDemo,
        },
        {
            path: '/admin/system-tools',
            name: 'admin-system-tools',
            component: AdminSystemTools,
        },
        {
            path: '/user/channels',
            name: 'user-channel-list',
            component: ChannelList,
        },
        {
            path: '/user/channels/:channelId',
            name: 'user-channel',
            component: Channel,
        },
    ],
});
